import { VehicleLocation } from 'server'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import useVehicleLocationListener from './useVehicleLocationListener'
import { useEffect, useState } from 'react'

const useVehicleLocationHistory = (vehicleId: number | undefined): VehicleLocation | undefined => {

  const client = useFeathersClient()

  const [history, setHistory] = useState<VehicleLocation[]>([])

  const { data: vehicleLocation } = useQuery({
    queryKey: ['vehicle-location', 'find', vehicleId],
    queryFn: () =>
      client.service('vehicle-location').find({
        query: {
          vehicle_id: vehicleId
        }
      }).then((res: any) => res.data[0]),
    enabled: !!vehicleId,
    refetchInterval: 30000
  })

  const updatedVehicleLocation = useVehicleLocationListener(vehicleId || 0)

  useEffect(() => {
    if (!updatedVehicleLocation) return
    setHistory((prevState: VehicleLocation[]) => {
      // Only keep five
      if (prevState.length > 5) {
        // Remove last item in array
        prevState.pop()
      }
      // only store unique update_received
      if (prevState.some((vl) => {
        return vl.update_received === updatedVehicleLocation.update_received
      })) {
        return prevState
      } else {
        prevState.unshift(updatedVehicleLocation)
        // sort
        prevState.sort((a, b) => {
          return a.update_received - b.update_received
        })
        return [...prevState]
      }
    })
  }, [updatedVehicleLocation])

  return {
    vehicleLocation: updatedVehicleLocation || vehicleLocation,
    history
  }
}

export default useVehicleLocationHistory
